import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { CitGlobalConstantService } from '../core/cit-global-constants.service';
import { CitHelpService } from './cit-help.service';
import { SubscriptionLike as ISubscription } from 'rxjs';
declare var assetBasePaths;
@Component({
    selector: 'cit-help',
    templateUrl: './cit-help.component.html',
    styleUrls: ['./cit-help.component.css']
})

export class CITHelpComponent {

  securityCentralURL: string;
  softwareLicenseActivationImage: string;
  excalmationMarkImage: string;
  presentationImage: string;
  softwareKeyLicensingOverviewPresentationURL: string;
  private subscriptions: ISubscription[] = [];
  helpText: any;
 
  constructor(public citGlobalConstantService: CitGlobalConstantService,public citHelpService:CitHelpService) {

    this.securityCentralURL = this.citGlobalConstantService.baseBerlinApplicationURL + "/#/securitycentral";
    this.softwareLicenseActivationImage = this.citGlobalConstantService.basePath + `${assetBasePaths}`+"/images/how-to-video-software-license-activation.png";
    this.excalmationMarkImage = this.citGlobalConstantService.basePath + `${assetBasePaths}`+ "/images/Exclamation_mark_orange.png";
    this.presentationImage = this.citGlobalConstantService.basePath + `${assetBasePaths}`+"/images/presentation-icon.png";
    this.softwareKeyLicensingOverviewPresentationURL = this.citGlobalConstantService.licenseGenearatorURL + `${assetBasePaths}`+"/Schneider-Electric-SCADA-Software-Licensing-Overview.pdf"
    }
    ngOnInit() {
      this.subscriptions.push(
        this.citHelpService.getDataForHelpUrl(`${assetBasePaths}`+'/data/helptext.json').subscribe(response => {
          let data;
          if(response != null)
          data = response        
          this.helpText = data.helpText.html;
         
        })
      );
      }
    
}
